import React, { useState, useEffect } from "react";

export default function StudentApiTest() {
  const [students, setStudents] = useState([]);
  const [newStudents, setNewStudents] = useState([
    {
      first_name: "",
      last_name: "",
      roll_number: "",
      teacher: "",
    },
  ]);
  const [loginData, setLoginData] = useState({
    username: "",
    password: "",
  });
  const [modifyData, setModifyData] = useState({
    id: "",
    first_name: "",
    last_name: "",
    roll_number: "",
    teacher: "",
    username: "",
    password: "",
    validity: true,
  });
  const [deleteIds, setDeleteIds] = useState("");
  const [teacherFilter, setTeacherFilter] = useState("");
  const [usernameChange, setUsernameChange] = useState({
    id: "",
    new_username: "",
  });

  // Add new students
  const handleAddStudents = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("/api/addnewstudents/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ students: newStudents }),
      });
      const data = await response.json();
      if (data.status === "success") {
        alert("Students added successfully!");
        console.log("Created students:", data);
        fetchStudents();
      } else {
        alert("Error: " + data.message);
      }
    } catch (error) {
      alert("Error adding students: " + error.message);
    }
  };

  // Fetch all students
  const fetchStudents = async () => {
    try {
      const url = teacherFilter
        ? `/api/getstudents/?teacherid=${teacherFilter}`
        : "/api/getstudents/";
      const response = await fetch(url);
      const data = await response.json();
      setStudents(data.students || []);
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };

  // Modify student
  const handleModifyStudent = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("/api/modifystudent/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(modifyData),
      });
      const data = await response.json();
      if (data.status === "success") {
        alert("Student modified successfully!");
        fetchStudents();
      }
    } catch (error) {
      alert("Error modifying student: " + error.message);
    }
  };

  // Student login
  const handleStudentLogin = async (e) => {
    e.preventDefault();
    try {
      const queryParams = new URLSearchParams(loginData).toString();
      const response = await fetch(
        `/api/getstudentbyusernameandpassword/?${queryParams}`
      );
      const data = await response.json();
      if (data.student) {
        alert("Login successful!");
        console.log("Student data:", data.student);
      } else {
        alert("Login failed: " + (data.error || "Unknown error"));
      }
    } catch (error) {
      alert("Login error: " + error.message);
    }
  };

  // Change username
  const handleChangeUsername = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("/api/changestudentusername/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(usernameChange),
      });
      const data = await response.json();
      if (data.status === "success") {
        alert("Username changed successfully!");
        fetchStudents();
      }
    } catch (error) {
      alert("Error changing username: " + error.message);
    }
  };

  // Delete students
  const handleDeleteStudents = async (e) => {
    e.preventDefault();
    try {
      const student_ids = deleteIds.split(",").map((id) => parseInt(id.trim()));
      const response = await fetch("/api/delstudents/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ student_ids }),
      });
      const data = await response.json();
      alert(data.message);
      if (data.status !== "error") {
        fetchStudents();
      }
    } catch (error) {
      alert("Error deleting students: " + error.message);
    }
  };

  // Add more student form fields
  const handleAddMoreStudents = () => {
    setNewStudents([
      ...newStudents,
      {
        first_name: "",
        last_name: "",
        roll_number: "",
        teacher: "",
      },
    ]);
  };

  // Handle new student form changes
  const handleNewStudentChange = (index, field, value) => {
    const updatedStudents = [...newStudents];
    updatedStudents[index] = {
      ...updatedStudents[index],
      [field]: value,
    };
    setNewStudents(updatedStudents);
  };

  useEffect(() => {
    fetchStudents();
  }, [teacherFilter]);

  return (
    <div style={{ padding: "20px" }}>
      <h2>Student API Testing Interface</h2>

      {/* Add New Students Form */}
      <div style={{ marginBottom: "20px" }}>
        <h3>Add New Students</h3>
        <form onSubmit={handleAddStudents}>
          {newStudents.map((student, index) => (
            <div key={index} style={{ marginBottom: "10px" }}>
              <input
                type="text"
                placeholder="First Name"
                value={student.first_name}
                onChange={(e) =>
                  handleNewStudentChange(index, "first_name", e.target.value)
                }
              />
              <input
                type="text"
                placeholder="Last Name"
                value={student.last_name}
                onChange={(e) =>
                  handleNewStudentChange(index, "last_name", e.target.value)
                }
              />
              <input
                type="text"
                placeholder="Roll Number"
                value={student.roll_number}
                onChange={(e) =>
                  handleNewStudentChange(index, "roll_number", e.target.value)
                }
              />
              <input
                type="number"
                placeholder="Teacher ID"
                value={student.teacher}
                onChange={(e) =>
                  handleNewStudentChange(index, "teacher", e.target.value)
                }
              />
            </div>
          ))}
          <button type="button" onClick={handleAddMoreStudents}>
            Add More Students
          </button>
          <button type="submit">Submit</button>
        </form>
      </div>

      {/* Student Login Form */}
      <div style={{ marginBottom: "20px" }}>
        <h3>Student Login</h3>
        <form onSubmit={handleStudentLogin}>
          <input
            type="text"
            placeholder="Username"
            value={loginData.username}
            onChange={(e) =>
              setLoginData((prev) => ({ ...prev, username: e.target.value }))
            }
          />
          <input
            type="password"
            placeholder="Password"
            value={loginData.password}
            onChange={(e) =>
              setLoginData((prev) => ({ ...prev, password: e.target.value }))
            }
          />
          <button type="submit">Login</button>
        </form>
      </div>

      {/* Modify Student Form */}
      <div style={{ marginBottom: "20px" }}>
        <h3>Modify Student</h3>
        <form onSubmit={handleModifyStudent}>
          <input
            type="number"
            placeholder="Student ID"
            value={modifyData.id}
            onChange={(e) =>
              setModifyData((prev) => ({ ...prev, id: e.target.value }))
            }
            required
          />
          <input
            type="text"
            placeholder="First Name"
            value={modifyData.first_name}
            onChange={(e) =>
              setModifyData((prev) => ({ ...prev, first_name: e.target.value }))
            }
          />
          <input
            type="text"
            placeholder="Last Name"
            value={modifyData.last_name}
            onChange={(e) =>
              setModifyData((prev) => ({ ...prev, last_name: e.target.value }))
            }
          />
          <input
            type="text"
            placeholder="Roll Number"
            value={modifyData.roll_number}
            onChange={(e) =>
              setModifyData((prev) => ({
                ...prev,
                roll_number: e.target.value,
              }))
            }
          />
          <button type="submit">Modify</button>
        </form>
      </div>

      {/* Change Username Form */}
      <div style={{ marginBottom: "20px" }}>
        <h3>Change Student Username</h3>
        <form onSubmit={handleChangeUsername}>
          <input
            type="number"
            placeholder="Student ID"
            value={usernameChange.id}
            onChange={(e) =>
              setUsernameChange((prev) => ({ ...prev, id: e.target.value }))
            }
          />
          <input
            type="text"
            placeholder="New Username"
            value={usernameChange.new_username}
            onChange={(e) =>
              setUsernameChange((prev) => ({
                ...prev,
                new_username: e.target.value,
              }))
            }
          />
          <button type="submit">Change Username</button>
        </form>
      </div>

      {/* Delete Students Form */}
      <div style={{ marginBottom: "20px" }}>
        <h3>Delete Students</h3>
        <form onSubmit={handleDeleteStudents}>
          <input
            type="text"
            placeholder="Student IDs (comma-separated)"
            value={deleteIds}
            onChange={(e) => setDeleteIds(e.target.value)}
          />
          <button type="submit">Delete</button>
        </form>
      </div>

      {/* Display Students */}
      <div>
        <h3>All Students</h3>
        <input
          type="number"
          placeholder="Filter by Teacher ID"
          value={teacherFilter}
          onChange={(e) => setTeacherFilter(e.target.value)}
        />
        <button onClick={fetchStudents}>Refresh Students List</button>
        <div style={{ marginTop: "10px" }}>
          {students.map((student, index) => (
            <div
              key={index}
              style={{
                border: "1px solid #ccc",
                padding: "10px",
                margin: "5px",
              }}
            >
              <pre>{JSON.stringify(student, null, 2)}</pre>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
